"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_components_form_checkbox_1 = require("@saatva-bits/pattern-library.components.form-checkbox");
const pattern_library_utils_price_format_1 = require("@saatva-bits/pattern-library.utils.price-format");
const selection_hooks_1 = require("../../../../selection.hooks");
const ProductSelectCheckbox_module_scss_1 = __importDefault(require("./ProductSelectCheckbox.module.scss"));
const SIDE_PANELS = {
    sidePanels: 'Side Panels',
    noSidePanels: 'No Side Panels'
};
/**
 * Mostly used for attachements, currently for sidepanels
 *
 * @param {Object} props
 * @param {string} props.productCode
 * @param {import('../../../../selection.types').Attribute} props.attributeCode
 * @param {string} props.className - container classnames
 * @param {string} props.dataSelector
 * @param {boolean} props.includedExtraPrice
 * @returns {import('react').ReactNode}
 */
const ProductSelectCheckbox = ({ productCode, attributeCode, className, dataSelector, includeExtraPrice = true }) => {
    // Currently selected variant
    const productState = (0, selection_hooks_1.useProductState)(productCode);
    // Option represents the currently selected value for this attribute code passed (in this case sidePanel)
    const option = (0, selection_hooks_1.useAttributeOptions)(productCode, attributeCode);
    // if the selected variant its one with a side panel then the target becomes this same variant without the side panels
    const targetOptionValue = option.selectedValue === SIDE_PANELS.sidePanels ? SIDE_PANELS.noSidePanels : SIDE_PANELS.sidePanels;
    const matchingVariant = (0, selection_hooks_1.useFindMatchingVariant)(productCode, option.code, targetOptionValue);
    const variantHasPrice = matchingVariant ? Math.abs(productState.price - matchingVariant.price) : null;
    const priceAddedProduct = variantHasPrice && includeExtraPrice ? ` - ${(0, pattern_library_utils_price_format_1.formatCurrency)(variantHasPrice)}` : '';
    const optionElements = (0, react_1.useMemo)(() => {
        return option && option.values.map((value) => {
            return {
                label: value.label,
                value: value.code,
                isSelected: value.isSelected
            };
        });
    }, [option]);
    // when the user clicks the checkbox, update the state of the attribute
    const toggleChecked = (checkedValue) => {
        const value = optionElements.find(item => !item.isSelected && item.value !== checkedValue);
        option.setAttributeValue(value === null || value === void 0 ? void 0 : value.value);
    };
    const hideOption = !option;
    if (hideOption)
        return null;
    // TODO: Update component to handle other product options beside sidePanels
    // Checked always means that a side panel is added
    const isChecked = option.selectedValue === SIDE_PANELS.sidePanels;
    const label = isChecked ? `Added ${option.displayName.toLowerCase()}` : `Add ${option.displayName.toLowerCase()}${priceAddedProduct}`;
    return ((0, jsx_runtime_1.jsx)("div", { "data-selector": dataSelector, className: className, children: (0, jsx_runtime_1.jsx)(pattern_library_components_form_checkbox_1.FormCheckbox, { className: ProductSelectCheckbox_module_scss_1.default.checkbox, id: option.code, value: option.selectedValue, label: label, checked: isChecked, hideLabel: false, disabled: false, onChange: (e) => toggleChecked(e.target.value) }) }));
};
ProductSelectCheckbox.propTypes = {
    /** The product code */
    productCode: prop_types_1.default.string,
    /** Attribute code (sidePanel, color, fabric..) */
    attributeCode: prop_types_1.default.string,
    /** Class for the container */
    className: prop_types_1.default.string,
    /** Data selector for the container */
    dataSelector: prop_types_1.default.string,
    /** Shows how much the price would be when attaching a panel */
    includeExtraPrice: prop_types_1.default.bool
};
exports.default = (0, react_1.memo)(ProductSelectCheckbox);
//# sourceMappingURL=ProductSelectCheckbox.js.map